/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
// utils
import { nmxScroll } from '../../components/scrollToAnchorCta/scrollToAnchorCta';

export default () => {

  useEffect(() => {
    if(typeof globalThis !== 'undefined'){
      // wait for page to fully render, then scroll to the section/element ID from the page URL (jump link)
      setTimeout(() => {
        const targetId = globalThis?.location?.hash?.substring(1) || '';
        if(targetId){
          nmxScroll(undefined, targetId);
        }
      }, 1000);
    }
  }, []);

  return null;
};

